var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#004f90",
      fillOpacity: 1
    },
    d: "M 28.703125 18.117188 C 28.703125 18.765625 28.179688 19.289062 27.53125 19.289062 C 26.882812 19.289062 26.359375 18.765625 26.359375 18.117188 C 26.359375 17.46875 26.882812 16.945312 27.53125 16.945312 C 28.179688 16.945312 28.703125 17.46875 28.703125 18.117188 Z M 28.703125 18.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#004f90",
      fillOpacity: 1
    },
    d: "M 27.53125 5.648438 C 25.152344 5.648438 23.222656 7.574219 23.222656 9.957031 C 23.222656 10.605469 23.746094 11.128906 24.394531 11.128906 C 25.039062 11.128906 25.566406 10.605469 25.566406 9.957031 C 25.566406 8.875 26.441406 7.992188 27.53125 7.992188 C 28.617188 7.992188 29.496094 8.875 29.496094 9.957031 C 29.496094 11.042969 28.617188 11.925781 27.53125 11.925781 C 26.882812 11.925781 26.359375 12.449219 26.359375 13.097656 L 26.359375 14.351562 C 26.359375 15 26.882812 15.523438 27.53125 15.523438 C 28.179688 15.523438 28.703125 15 28.703125 14.351562 L 28.703125 14.105469 C 30.511719 13.59375 31.839844 11.929688 31.839844 9.957031 C 31.839844 7.582031 29.90625 5.648438 27.53125 5.648438 Z M 27.53125 5.648438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#004f90",
      fillOpacity: 1
    },
    d: "M 11.246094 29.90625 C 12.703125 28.773438 13.640625 27.003906 13.640625 25.019531 C 13.640625 21.605469 10.863281 18.828125 7.449219 18.828125 C 4.03125 18.828125 1.253906 21.605469 1.253906 25.019531 C 1.253906 27.003906 2.195312 28.773438 3.652344 29.90625 C 1.59375 31.128906 0 33.4375 0 36.316406 L 0 38.828125 C 0 39.476562 0.523438 40 1.171875 40 L 13.722656 40 C 14.371094 40 14.894531 39.476562 14.894531 38.828125 L 14.894531 36.316406 C 14.894531 33.4375 13.300781 31.128906 11.246094 29.90625 Z M 3.597656 25.019531 C 3.597656 22.898438 5.324219 21.171875 7.449219 21.171875 C 9.570312 21.171875 11.296875 22.898438 11.296875 25.019531 C 11.296875 27.144531 9.570312 28.871094 7.449219 28.871094 C 5.324219 28.871094 3.597656 27.144531 3.597656 25.019531 Z M 12.550781 37.65625 L 2.34375 37.65625 L 2.34375 36.316406 C 2.34375 33.5 4.625 31.214844 7.449219 31.214844 C 10.265625 31.214844 12.550781 33.496094 12.550781 36.316406 Z M 12.550781 37.65625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#004f90",
      fillOpacity: 1
    },
    d: "M 35.0625 0 L 20 0 C 17.273438 0 15.0625 2.207031 15.0625 4.9375 L 15.0625 27.53125 C 15.0625 28.488281 16.160156 29.050781 16.9375 28.46875 L 21.644531 24.9375 L 35.0625 24.9375 C 37.789062 24.9375 40 22.730469 40 20 L 40 4.9375 C 40 2.210938 37.792969 0 35.0625 0 Z M 37.65625 20 C 37.65625 21.433594 36.496094 22.59375 35.0625 22.59375 L 21.253906 22.59375 C 21 22.59375 20.753906 22.675781 20.550781 22.828125 L 17.40625 25.1875 L 17.40625 4.9375 C 17.40625 3.503906 18.566406 2.34375 20 2.34375 L 35.0625 2.34375 C 36.496094 2.34375 37.65625 3.503906 37.65625 4.9375 Z M 37.65625 20 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/request.83fee562.svg";
export { ForwardRef as ReactComponent };